// Central data file for AENHCC. Edit here to swap images/text without touching components.
// Para trocar as fotos: substitua as URLs abaixo ou coloque fotos em /app/frontend/public/fotos/
// e use caminhos como "/fotos/hero.jpg". Depois rode `yarn build` novamente.

export const SITE = {
    brand: "Novo Horizonte",
    brandShort: "AENHCC",
    fullName:
        "Associação Esportiva Novo Horizonte de Canaã dos Carajás",
    tagline: "Meninas vencedoras — no campo e na comunidade.",
    since: "2005",
    location:
        "Rua Paraná, nº 144 · Bairro Novo Horizonte · Canaã dos Carajás · PA · CEP 68356-167",
    cnpj: "39.231.285/0001-07",
    phones: ["(94) 98157-6965", "(94) 99282-1992", "(94) 99259-2785"],
    instagram: "https://www.instagram.com/novo_horizonte.futebol.club/",
    email: "esportivanh.captacao@gmail.com",
};

// Fotos reais do Projeto Meninas Vencedoras 2025/2026 (Eletrobras)
export const IMAGES = {
    hero: "/fotos/hero.jpg",
    portrait: "/fotos/portrait.jpg",
    training: "/fotos/training.jpg",
    community: "/fotos/community.jpg",
    gallery: [
        "/fotos/g1.jpg",
        "/fotos/g2.jpg",
        "/fotos/g3.jpg",
        "/fotos/g4.jpg",
        "/fotos/g5.jpg",
        "/fotos/g6.jpg",
        "/fotos/g7.jpg",
        "/fotos/g8.jpg",
    ],
};

export const CHAPTERS = [
    {
        n: "01",
        title: "O Início",
        year: "2005",
        body: "No Bairro Novo Horizonte — um dos mais desprovidos de infraestrutura de Canaã dos Carajás — uma bola rolou pela primeira vez e trouxe consigo um propósito. A AENHCC nasce como espaço onde crianças e adolescentes pudessem sonhar em movimento, antes de qualquer troféu, antes de qualquer campeonato.",
    },
    {
        n: "02",
        title: "Regularização",
        year: "2020",
        body: "Após 15 anos formando gerações no futebol de base, a Associação Esportiva Novo Horizonte se torna oficialmente uma OSC (Organização da Sociedade Civil). É a estrutura que faltava para transformar dedicação em política pública — esporte em direito.",
    },
    {
        n: "03",
        title: "Meninas Vencedoras",
        year: "2025—2026",
        body: "Com apoio da Eletrobras e do Ministério do Esporte via Lei de Incentivo ao Esporte, nasce o projeto “Meninas Vencedoras no Campo e na Comunidade”. Aulas gratuitas de futebol de campo, futevôlei e vôlei, exclusivamente para meninas de 6 a 18 anos. Uma frente pensada para elas, com elas, por elas.",
    },
    {
        n: "04",
        title: "Hoje",
        year: "Agora",
        body: "Ações de esporte, educação e cidadania se cruzam: Setembro Amarelo, Novembro Dourado, oficinas do ECA, medalhas em campeonatos regionais. O futebol nos trouxe até aqui. A cidadania — e o protagonismo feminino — nos levam adiante.",
    },
];

export const ACOES = [
    {
        n: "A.01",
        title: "Futebol · Futevôlei · Vôlei",
        desc: "Aulas gratuitas de técnicas desportivas exclusivamente para meninas de 6 a 18 anos. Fundamentos, coletividade, disciplina e alegria.",
    },
    {
        n: "A.02",
        title: "Esporte + Educação",
        desc: "Oficinas do ECA, palestras sobre direitos, autoestima e projeto de vida. O treino continua depois que a bola para.",
    },
    {
        n: "A.03",
        title: "Alto Rendimento",
        desc: "Equipes de base com atletas premiadas em campeonatos regionais e intermunicipais — do sub-12 ao sub-17.",
    },
    {
        n: "A.04",
        title: "Ações na Comunidade",
        desc: "Campanhas de saúde mental (Setembro Amarelo), prevenção (Novembro Dourado), ações solidárias e integração com CRAS Novo Horizonte.",
    },
];

export const STATS = [
    { value: "6—18", label: "Anos · Meninas atendidas" },
    { value: "20", label: "Anos de História" },
    { value: "3", label: "Modalidades · Futebol · Futevôlei · Vôlei" },
    { value: "OSC", label: "Regularizada · 2020" },
];

export const MARQUEE =
    "MENINAS VENCEDORAS · NO CAMPO E NA COMUNIDADE · PROJETO ELETROBRAS · DESDE 2005 · CANAÃ DOS CARAJÁS · ";

export const PARTNERS = [
    "Eletrobras",
    "Ministério do Esporte",
    "Governo Federal · Brasil",
    "Lei de Incentivo ao Esporte",
    "CRAS Novo Horizonte",
    "Prefeitura de Canaã dos Carajás",
];

// ============================================================
// PROJETO MENINAS VENCEDORAS — dados editáveis livremente
// ============================================================

export const PROJETO = {
    nome: "Meninas Vencedoras no Campo e na Comunidade",
    proponente: "Associação Esportiva Novo Horizonte de Canaã dos Carajás",
    processo: "71000.036162/2023-29",
    sli: "2300669",
    patrocinador: "Eletrobras",
    apoio: "Ministério do Esporte · Lei de Incentivo ao Esporte · Governo Federal",
    periodo: "2025 — 2026",
    publicoAlvo:
        "Meninas de 6 a 18 anos residentes no Bairro Novo Horizonte e adjacências, em Canaã dos Carajás — PA.",
    modalidades: ["Futebol de Campo", "Futevôlei", "Vôlei"],
    manifesto:
        "Transformar vidas por meio do esporte, educação e cidadania — colocando meninas no centro do jogo, no campo e na comunidade.",
    objetivosGerais: [
        "Ofertar gratuitamente aulas de técnicas desportivas de futebol de campo, futevôlei e vôlei exclusivamente para meninas.",
        "Fortalecer autoestima, disciplina, protagonismo feminino e cidadania.",
        "Reduzir vulnerabilidade social em um dos bairros mais desprovidos de infraestrutura de Canaã dos Carajás.",
        "Integrar esporte, educação (ECA, direitos, saúde mental) e ações comunitárias.",
    ],
};

// Timeline histórica — desde a fundação até hoje
export const TIMELINE = [
    {
        data: "2005",
        titulo: "Fundação informal",
        desc: "Início das atividades esportivas no Bairro Novo Horizonte, ainda sem CNPJ, por moradores e voluntários da comunidade.",
    },
    {
        data: "2020",
        titulo: "Regularização como OSC",
        desc: "A AENHCC é oficialmente registrada como Organização da Sociedade Civil. CNPJ 39.231.285/0001-07.",
    },
    {
        data: "2021",
        titulo: "Projeto Novo Horizonte",
        desc: "Primeiro projeto formal, com emendas impositivas da Câmara Municipal e do CMDCA. 30 crianças e adolescentes atendidos com apoio nutricional e técnico.",
    },
    {
        data: "2022",
        titulo: "Expansão de programas",
        desc: "Termo de Fomento n° 012/2022 e 02/2022. Ampliação dos meses de operação, materiais e grupo intensivo.",
    },
    {
        data: "Jan · 2025",
        titulo: "Aprovação Lei de Incentivo",
        desc: "Projeto Meninas Vencedoras aprovado pelo Ministério do Esporte via Lei de Incentivo ao Esporte. SLI n° 2300669.",
    },
    {
        data: "2025 — 2026",
        titulo: "Meninas Vencedoras · em execução",
        desc: "Patrocínio Eletrobras. Aulas gratuitas para meninas de 6–18 anos em futebol, futevôlei e vôlei. Ações educativas e comunitárias em curso.",
    },
];

// Cronograma físico das atividades — o que acontece a cada mês
export const CRONOGRAMA = [
    {
        mes: "Mês 1",
        etapa: "Mobilização",
        atividades: [
            "Divulgação do projeto na comunidade",
            "Inscrições e triagem",
            "Compra de materiais esportivos",
        ],
    },
    {
        mes: "Mês 2",
        etapa: "Início das aulas",
        atividades: [
            "Aulas regulares de futebol, futevôlei e vôlei",
            "Avaliação física e nutricional",
            "Formação da equipe técnica",
        ],
    },
    {
        mes: "Mês 3 — 4",
        etapa: "Ciclo educativo",
        atividades: [
            "Oficinas do ECA e direitos das crianças",
            "Campanha Setembro Amarelo (saúde mental)",
            "Encontro com famílias",
        ],
    },
    {
        mes: "Mês 5 — 6",
        etapa: "Campeonatos internos",
        atividades: [
            "Torneios entre categorias",
            "Campanha Novembro Dourado",
            "Encontros esportivos com escolas parceiras",
        ],
    },
    {
        mes: "Mês 7 — 8",
        etapa: "Alto rendimento",
        atividades: [
            "Preparação para competições regionais",
            "Peneiras técnicas",
            "Passeios formativos (turismo educativo)",
        ],
    },
    {
        mes: "Mês 9 — 10",
        etapa: "Prestação intermediária",
        atividades: [
            "Relatório parcial ao patrocinador",
            "Auditoria interna",
            "Retomada intensiva",
        ],
    },
    {
        mes: "Mês 11 — 12",
        etapa: "Encerramento",
        atividades: [
            "Cerimônia de encerramento",
            "Entrega de medalhas e certificados",
            "Relatório final e prestação de contas",
        ],
    },
];

// Prestação de contas — valores editáveis a qualquer momento
export const PRESTACAO = {
    valorAprovado: "R$ 385.500,00",
    valorCaptado: "R$ 385.500,00",
    valorExecutado: "R$ 154.200,00",
    percentualExecutado: 40,
    rubricas: [
        {
            rubrica: "Recursos humanos (coord., professores, monitoras)",
            aprovado: "R$ 168.000",
            executado: "R$ 67.200",
            percentual: 40,
        },
        {
            rubrica: "Material esportivo (uniformes, bolas, redes)",
            aprovado: "R$ 62.500",
            executado: "R$ 58.400",
            percentual: 93,
        },
        {
            rubrica: "Alimentação e água",
            aprovado: "R$ 48.000",
            executado: "R$ 12.900",
            percentual: 27,
        },
        {
            rubrica: "Locação de espaço e transporte",
            aprovado: "R$ 42.000",
            executado: "R$ 8.200",
            percentual: 20,
        },
        {
            rubrica: "Divulgação e comunicação",
            aprovado: "R$ 25.000",
            executado: "R$ 4.500",
            percentual: 18,
        },
        {
            rubrica: "Administrativo e prestação de contas",
            aprovado: "R$ 40.000",
            executado: "R$ 3.000",
            percentual: 8,
        },
    ],
    documentos: [
        {
            nome: "Plano de Trabalho Aprovado",
            desc: "Documento base do projeto aprovado pelo Ministério do Esporte.",
        },
        {
            nome: "Relatório Parcial de Execução",
            desc: "Prestação intermediária correspondente ao 6º mês.",
        },
        {
            nome: "Notas Fiscais Consolidadas",
            desc: "Arquivos das rubricas de RH, material e alimentação.",
        },
        {
            nome: "Registro Fotográfico",
            desc: "Comprovação visual das atividades executadas.",
        },
    ],
};

// Métricas de impacto — atualize conforme dados reais
export const IMPACTO = [
    { valor: "120+", label: "Meninas atendidas" },
    { valor: "3", label: "Modalidades ofertadas" },
    { valor: "6h", label: "Aulas semanais por turma" },
    { valor: "12", label: "Meses de execução" },
];
